import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcModalSuccess = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 61,
	height: 60,
	viewBox: "0 0 61 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M30.5 0C24.5666 0 18.7664 1.75947 13.8329 5.05591C8.89943 8.35235 5.05426 13.0377 2.78363 18.5195C0.512999 24.0013 -0.0811014 30.0333 1.07645 35.8527C2.23401 41.6721 5.09123 47.0176 9.28681 51.2132C13.4824 55.4088 18.8279 58.266 24.6473 59.4235C30.4667 60.5811 36.4987 59.987 41.9805 57.7164C47.4623 55.4457 52.1476 51.6006 55.4441 46.6671C58.7405 41.7336 60.5 35.9334 60.5 30C60.4906 22.0464 57.3269 14.4212 51.7028 8.79716C46.0788 3.1731 38.4536 0.0093831 30.5 0ZM30.5 54.5454C25.6454 54.5454 20.8998 53.1059 16.8633 50.4088C12.8268 47.7117 9.68076 43.8782 7.82297 39.3931C5.96518 34.908 5.4791 29.9728 6.42619 25.2114C7.37328 20.4501 9.71101 16.0765 13.1438 12.6437C16.5765 9.211 20.9501 6.87327 25.7114 5.92618C30.4728 4.97909 35.408 5.46517 39.8931 7.32296C44.3782 9.18074 48.2117 12.3268 50.9088 16.3633C53.6059 20.3998 55.0455 25.1454 55.0455 30C55.0375 36.5074 52.4489 42.746 47.8475 47.3475C43.246 51.9489 37.0074 54.5375 30.5 54.5454Z",
			fill: "#03A65B"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M43.258 19.5584C44.1705 20.3695 44.2527 21.7667 43.4416 22.6791L26.0702 42.222L16.5584 31.5212C15.7473 30.6088 15.8295 29.2116 16.742 28.4005C17.6544 27.5894 19.0516 27.6716 19.8627 28.584L26.0702 35.5674L40.1373 19.742C40.9484 18.8295 42.3456 18.7473 43.258 19.5584Z",
			fill: "#03A65B"
		})
	]
});
const ForwardRef = forwardRef(SvgIcModalSuccess);
export default ForwardRef;
